"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.localisedRoutes = exports.Page = void 0;
var Page;
(function (Page) {
    Page["Profile"] = "page-profile";
    Page["Product"] = "page-product";
    Page["Login"] = "page-login";
    Page["Register"] = "page-register";
    Page["Cart"] = "page-cart";
    Page["Shop"] = "page-shop";
    Page["Checkout"] = "page-checkout";
    Page["CheckoutSuccess"] = "page-checkout-success";
    Page["Blog"] = "page-blog";
    Page["Post"] = "page-post";
    Page["ForgotPassword"] = "page-forgot-password";
    Page["Search"] = "page-search";
    Page["SocialLogin"] = "page-social-login";
    Page["Event"] = "page-event";
    Page["ConfirmEmail"] = "page-confirm-email";
})(Page = exports.Page || (exports.Page = {}));
exports.localisedRoutes = (_a = {},
    _a[Page.Product] = {
        en: '/product/:slug?',
        hr: '/product/:slug?',
        de: '/produkt/:slug?',
    },
    _a[Page.Login] = {
        en: '/login',
        hr: '/prijava',
        de: '/login',
    },
    _a[Page.Register] = {
        en: '/register',
        hr: '/registracija',
        de: '/register',
    },
    _a[Page.Profile] = {
        en: '/profile',
        hr: '/profil',
        de: '/profil',
    },
    _a[Page.Cart] = {
        en: '/cart',
        hr: '/kosarica',
        de: '/einkaufswagen',
    },
    _a[Page.Shop] = {
        en: '/shop/:slug?',
        hr: '/shop/:slug?',
        de: '/shop/:slug?',
    },
    _a[Page.Checkout] = {
        en: '/checkout',
        hr: '/naplata',
        de: '/kasse',
    },
    _a[Page.CheckoutSuccess] = {
        en: '/checkout/success',
        hr: '/naplata/uspjesna',
        de: '/checkout/success',
    },
    _a[Page.Search] = {
        en: '/search',
        hr: '/pretraga',
        de: '/suche',
    },
    _a[Page.Post] = {
        en: '/:slug?',
        hr: '/:slug?',
        de: '/:slug?',
    },
    _a[Page.Blog] = {
        en: '/blog/:slug?',
        hr: '/objave/:slug?',
        de: '/blog/:slug?',
    },
    _a[Page.ForgotPassword] = {
        en: '/forgot-password',
        hr: '/zaboravljena-lozinka',
        de: '/passwort-vergessen',
    },
    _a[Page.SocialLogin] = {
        en: '/social-login',
        hr: '/social-login',
        de: '/social-login',
    },
    _a[Page.Event] = {
        en: '/event/:id',
        hr: '/dogadjaj/:id',
        de: '/Veranstaltung/:id',
    },
    _a[Page.ConfirmEmail] = {
        en: '/confirm-email',
        hr: '/potvrdi-email',
        de: '/bestatigungs-email'
    },
    _a);
